import styled from '@emotion/styled';
import { theme } from '@travelnest/hui';

export const InfoCard = styled.div`
	background-color: 'white';
	border: 1px solid ${theme.colors.LM_NU30T};
	border-radius: 16px;

	display: flex;
	flex-direction: column;
	flex-grow: 1;
	justify-content: space-between;

	overflow: hidden;
	padding: 16px;
	width: 100%;

	@media screen and (min-width: 1366px) {
		padding: 24px;
	}
`;
